import { __assign } from "tslib";
import React, { useState } from "react";
import { Linking, Platform, View } from "react-native";
import { PnmacHeadline, PnmacHtmlToNative, PnmacSubheading, PnmacText, PnmacUIButton } from "pnmac-universal-components";
import { TrackerActionLID_ENUM, TrackerCategoryLID_ENUM, TrackerHitTypeLID_ENUM, UserLanguage_ENUM } from "../../redux/events/events.js";
import { useDispatch, useSelector } from "react-redux";
import { bindActionCreators } from "redux";
import * as Actions from "../../redux/actions/actions.js";
import Payoff from "./Payoff";
import { genericStatusCheck } from "../../utils";
import GetPayoffNotAvailable from "./GetPayoffNotAvailable";
import GetPayoffStatement from "./GetPayoffStatement";
import { textStyle } from '../../v2/theme';
import { trackEvent } from '../../Tealium';
function getFullZone(zone) {
  if (zone === void 0) {
    zone = "";
  }
  switch (zone) {
    case "refi":
      {
        return "Refinance with Another Lender - Send Free Quote button Clicked";
      }
    case "sell":
      {
        return "Sell My Home - Send Free Quote button Clicked";
      }
    case "purchase":
      {
        return "Purchase a New Home - Send Free Quote button Clicked";
      }
  }
}
function getPayoffReason(zone) {
  if (zone === void 0) {
    zone = "";
  }
  switch (zone) {
    case "refi":
      {
        return "Refinance with PennyMac";
      }
    case "sell":
      {
        return "Sell My Home";
      }
    case "purchase":
      {
        return "Purchase a New Home";
      }
  }
}
function RefiLender(_a) {
  var _b, _c;
  var translations = _a.translations,
    _d = _a.purchaseHome,
    purchaseHome = _d === void 0 ? false : _d,
    _e = _a.zone,
    zone = _e === void 0 ? "refi" : _e,
    tealiumReason = _a.tealiumReason;
  var dispatch = useDispatch();
  var trackerDispatcher = bindActionCreators(Actions, dispatch).trackerDispatcher;
  var state = useSelector(function (state) {
    return state;
  });
  var status = ((_b = state === null || state === void 0 ? void 0 : state.selectedLoanAvailability) === null || _b === void 0 ? void 0 : _b.status) || {};
  var payedOff = (_c = genericStatusCheck(status, "completeOne", ["servicereleased"])) === null || _c === void 0 ? void 0 : _c.hasSubStatus;
  var _f = useState("RefiLender"),
    route = _f[0],
    setRoute = _f[1];
  switch (route) {
    case "GetPayoffNotAvailable":
      {
        return /*#__PURE__*/React.createElement(GetPayoffNotAvailable, null);
      }
    case "GetPayoffStatement":
      {
        return /*#__PURE__*/React.createElement(GetPayoffStatement, {
          translations: translations,
          payOffReason: getPayoffReason(zone),
          tealiumReason: tealiumReason
        });
      }
    default:
      {
        return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(View, {
          style: styles.container
        }, /*#__PURE__*/React.createElement(PnmacUIButton, {
          style: styles.button,
          mode: "contained",
          onPress: function () {
            trackerDispatcher(UserLanguage_ENUM.English, TrackerCategoryLID_ENUM.Button, TrackerHitTypeLID_ENUM.Event, TrackerActionLID_ENUM.Click, getFullZone(zone), 0);
            Platform.OS === "web" ? window.open("https://www.pennymac.com/mortgage-rates?icn=payoff&zone=" + zone, "_blank") : Linking.openURL("https://www.pennymac.com/mortgage-rates?icn=payoff&zone=" + zone);
          }
        }, translations.SendInfoFreeQuote), /*#__PURE__*/React.createElement(PnmacText, {
          style: styles.text
        }, translations.Payoff_OR), /*#__PURE__*/React.createElement(PnmacText, {
          style: styles.text
        }, translations.Payoff_Not_Interested), /*#__PURE__*/React.createElement(PnmacUIButton, {
          onPress: function () {
            trackEvent('payoff_request_started', {
              'payoff_reason': tealiumReason,
              start_time: new Date()
            });
            setRoute(payedOff ? "GetPayoffNotAvailable" : "GetPayoffStatement");
          },
          style: {
            backgroundColor: "transparent",
            boxShadow: "none"
          }
        }, /*#__PURE__*/React.createElement(PnmacSubheading, {
          style: __assign(__assign({}, textStyle.defaultTextDescription), {
            color: "#003087",
            fontSize: 18
          })
        }, translations === null || translations === void 0 ? void 0 : translations.RequestPayoffStatement))), !purchaseHome && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(PnmacHeadline, {
          style: styles.headline
        }, translations.BenefitsofRefinancing), /*#__PURE__*/React.createElement(PnmacHtmlToNative, {
          value: (translations === null || translations === void 0 ? void 0 : translations.Competitivelowrates1) + (translations === null || translations === void 0 ? void 0 : translations.Competitivelowrates2)
        })), /*#__PURE__*/React.createElement(Payoff, {
          translations: translations,
          showKnow: purchaseHome
        }));
      }
  }
}
var styles = {
  headline: {
    marginHorizontal: 5,
    marginTop: 20
  },
  container: {
    alignItems: "center",
    backgroundColor: "#fff",
    shadowColor: "rgba(0,0,0, .08)",
    shadowOffset: {
      height: 4,
      width: 2
    },
    shadowOpacity: 1,
    shadowRadius: 12,
    elevation: 4,
    borderRadius: 10,
    paddingVertical: 20,
    marginVertical: 10,
    marginHorizontal: 5
  },
  text: __assign(__assign({}, textStyle.defaultTextTitle), {
    color: "#707070",
    marginTop: 5
  }),
  button: {
    marginBottom: 10,
    paddingHorizontal: Platform.OS === 'web' ? 120 : 20,
    marginTop: 10
  }
};
export default RefiLender;